// ============================================================================
// ACCOUNT SUBTYPE SERVICE (read-only)
// ============================================================================

import { get } from '../client/axiosClient';
import { accountSubtypeEndpoints } from '../endpoints/accounts.endpoints';
import { buildEndpointWithQuery } from '../endpoints/base.endpoints';
import type {
  ApiResponse,
  BackendPagedResult,
  PaginatedResponse,
  ID,
  AccountSubtypeDto,
  AccountSubtypeQueryParams,
} from '../types';

class AccountSubtypeService {
  async getAll(params?: AccountSubtypeQueryParams): Promise<PaginatedResponse<AccountSubtypeDto>> {
    const endpoint = params
      ? buildEndpointWithQuery(accountSubtypeEndpoints.list(), params)
      : accountSubtypeEndpoints.list();
    const response = await get<ApiResponse<BackendPagedResult<AccountSubtypeDto>>>(endpoint);
    const paged = response.data.data;
    return {
      success: response.data.success,
      message: response.data.message,
      data: Array.from(paged.items || []),
      pagination: {
        currentPage: paged.page,
        pageSize: paged.pageSize,
        totalPages: paged.totalPages,
        totalItems: paged.totalCount,
        hasNextPage: paged.hasNext,
        hasPreviousPage: paged.hasPrevious,
      },
    };
  }

  async getById(id: ID): Promise<ApiResponse<AccountSubtypeDto>> {
    const response = await get<ApiResponse<AccountSubtypeDto>>(accountSubtypeEndpoints.getById(id));
    return response.data;
  }
}

export const accountSubtypeService = new AccountSubtypeService();
export default accountSubtypeService;
